"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _adSolution = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/ad-solution.store"));
var _asyncSearchResults = _interopRequireDefault(require("../../api/async-search-results.store"));
var _fareCalendar = _interopRequireDefault(require("../../api/fare-calendar.store"));
var _filter = _interopRequireDefault(require("../../filter"));
var _sort = _interopRequireDefault(require("../../sort.store"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _filtersData = require("../../../utils/filters/filters-data.utils");
var _group = _interopRequireWildcard(require("../../../utils/group.utils"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _sort2 = require("../../../utils/sort.utils");
var _search = _interopRequireDefault(require("../../../utils/search.utils"));
var _common = require("../../../utils/filters/common.utils");
var _sort3 = require("../../../utils/sort/sort.utils");
var _adPlacments = require("../../../utils/ad-placments.utils");
var _constants = require("../../../constants");
var _searchResults = require("../../../utils/search-results.utils");
var _sort4 = require("../../../constants/sort.constants");
var _filters = require("../../../constants/filters.constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SearchPageStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, _dec17 = _mobx.action.bound, _dec18 = _mobx.action.bound, _dec19 = _mobx.action.bound, _dec20 = _mobx.action.bound, _dec21 = _mobx.action.bound, _dec22 = _mobx.action.bound, _dec23 = _mobx.action.bound, _dec24 = _mobx.action.bound, _dec25 = _mobx.action.bound, (_class = function () {
  function SearchPageStore(initialState, $env, flightInfo) {
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, SearchPageStore);
    this.$env = void 0;
    this.searchResults = {};
    this.fareCalendar = void 0;
    this.filters = void 0;
    this.sort = void 0;
    this.filterDisposer = void 0;
    this.sortDisposer = void 0;
    this.fareCalendarDisposer = void 0;
    this.groupsDisposer = void 0;
    this.sortDefaultKeyDisposer = void 0;
    this.adSolution = void 0;
    (0, _initializerDefineProperty2.default)(this, "groupPaths", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "minGroupLength", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "selectedGroupItineraries", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "selectedFareFamilyItinerary", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "selectedItinerary", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "displayItinerary", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "itinerariesGroupState", _descriptor7, this);
    (0, _initializerDefineProperty2.default)(this, "groupsState", _descriptor8, this);
    (0, _initializerDefineProperty2.default)(this, "preservedFilters", _descriptor9, this);
    this.$env = $env;
    this.fareCalendar = new _fareCalendar.default(initialState.fareCalendar, $env);
    this.filters = new _filter.default(initialState.filters, $env, flightInfo);
    this.sort = new _sort.default(initialState.sort, $env);
    this.adSolution = new _adSolution.default({}, $env, _constants.AD_SOLUTION_PATH.APP);
    this.searchResults = new _asyncSearchResults.default(initialState.searchResults, $env);
    this.initializeAutoruns();
  }
  (0, _createClass2.default)(SearchPageStore, [{
    key: "itinerariesGroups",
    get: function get() {
      return this.itinerariesGroupState;
    }
  }, {
    key: "itineraryFromGroupState",
    get: function get() {
      var _this = this;
      return function (index) {
        var _this$itinerariesGrou = _this.itinerariesGroupState[index],
          selectedInboundId = _this$itinerariesGrou.selectedInboundId,
          selectedOutboundId = _this$itinerariesGrou.selectedOutboundId;
        var _this$searchResults$s = _this.searchResults.searchRequest,
          isRoundTrip = _this$searchResults$s.isRoundTrip,
          isOneWay = _this$searchResults$s.isOneWay;
        if (isRoundTrip && !(0, _isEmpty2.default)(selectedInboundId) && !(0, _isEmpty2.default)(selectedOutboundId)) {
          return _this.searchResults.itineraryLegHashMap[[selectedOutboundId, selectedInboundId].join(_constants.LEG_IDS_SEPARATOR)];
        }
        if (isOneWay && !(0, _isEmpty2.default)(selectedOutboundId)) {
          return _this.searchResults.itineraryLegHashMap[selectedOutboundId];
        }
      };
    }
  }, {
    key: "filtersData",
    get: function get() {
      return (0, _filtersData.getFiltersData)(this.allSearchResults);
    }
  }, {
    key: "firstNearByAirportItineraryId",
    get: function get() {
      var itineraries = (0, _searchResults.getTopPickCombinedItineraries)(this.groupedSearchResults, this.isTopPicksReady ? this.topPicksItineraries : []);
      return (0, _searchResults.getFirstNearbyItineraryId)(itineraries);
    }
  }, {
    key: "isNearbyAirportInTopPicks",
    get: function get() {
      var _this$topPicksItinera,
        _this2 = this;
      return this.isTopPicksReady && !!((_this$topPicksItinera = this.topPicksItineraries) !== null && _this$topPicksItinera !== void 0 && _this$topPicksItinera.find(function (itinerary) {
        return itinerary.id === _this2.firstNearByAirportItineraryId;
      }));
    }
  }, {
    key: "allSearchResults",
    get: function get() {
      return this.searchResults.itineraries;
    }
  }, {
    key: "filteredSearchResults",
    get: function get() {
      if (this.filters.isReady && this.filters.state) return this.filters.filter(this.allSearchResults);
      return this.allSearchResults;
    }
  }, {
    key: "sortedSearchResults",
    get: function get() {
      return this.sort.sort(this.filteredSearchResults);
    }
  }, {
    key: "itineraryGroups",
    get: function get() {
      return (0, _group.default)(this.sortedSearchResults, this.groupPaths, this.minGroupLength);
    }
  }, {
    key: "itineraryGroupMap",
    get: function get() {
      return (0, _group.itineraryGroupMap)(this.itineraryGroups);
    }
  }, {
    key: "groupedSearchResults",
    get: function get() {
      return !this.isTopPicksReady ? this.itineraryGroups : this.resultsWithoutTopPicks;
    }
  }, {
    key: "groupedByLegSearchResults",
    get: function get() {
      return (0, _group.getGroupedByLegSearchResults)({
        groupsState: this.groupsState,
        itineraryLegHashMap: this.searchResults.itineraryLegHashMap,
        legHashMap: this.searchResults.legHashMap
      });
    }
  }, {
    key: "selectedItineraryFareFamilies",
    get: function get() {
      var _this$selectedFareFam;
      return (_this$selectedFareFam = this.selectedFareFamilyItinerary) === null || _this$selectedFareFam === void 0 ? void 0 : _this$selectedFareFam.fareFamilies;
    }
  }, {
    key: "resultsWithoutTopPicks",
    get: function get() {
      return (0, _sort2.getResultsWithoutTopPicks)({
        topPicks: this.topPicks,
        searchResults: this.itineraryGroups,
        isDomestic: false
      });
    }
  }, {
    key: "topScoreItineraries",
    get: function get() {
      return (0, _sort3.getTopScoreItineraries)(this.filteredSearchResults);
    }
  }, {
    key: "topPicks",
    get: function get() {
      return (0, _sort2.getTopPicks)(this.topScoreItineraries);
    }
  }, {
    key: "topPicksItineraries",
    get: function get() {
      return (0, _map2.default)(this.topPicks, "itinerary");
    }
  }, {
    key: "isTopPicksReady",
    get: function get() {
      return this.$env.config.isMobile ? this.isMobileTopPicksReady : this.isDesktopTopPicksReady;
    }
  }, {
    key: "isMobileTopPicksReady",
    get: function get() {
      return !this.sort.isTouched && !(0, _isEmpty2.default)(this.resultsWithoutTopPicks);
    }
  }, {
    key: "isDesktopTopPicksReady",
    get: function get() {
      return this.sort.selectedItem === _sort4.SORT_BY_MAP.BEST.key && !(0, _isEmpty2.default)(this.resultsWithoutTopPicks);
    }
  }, {
    key: "sortPriceDurationHashMap",
    get: function get() {
      return (0, _sort3.getSortPriceDurationHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "searchQuery",
    get: function get() {
      return this.searchResults.searchQuery;
    }
  }, {
    key: "isMultiCity",
    get: function get() {
      return _search.default.checkMultiCity(this.searchQuery);
    }
  }, {
    key: "isEconomy",
    get: function get() {
      return _search.default.checkEconomyCabin(this.searchQuery);
    }
  }, {
    key: "hasAdultsOnly",
    get: function get() {
      return !this.searchQuery.includes("Child") && !this.searchQuery.includes("Infant");
    }
  }, {
    key: "searchRoute",
    get: function get() {
      return _search.default.getRouteFromQuery(this.searchQuery);
    }
  }, {
    key: "isFareCalendarAvailable",
    get: function get() {
      return this.isEconomy && !this.isMultiCity;
    }
  }, {
    key: "parseSearchQuery",
    get: function get() {
      return _search.default.getParsedSearchQuery(this.searchQuery);
    }
  }, {
    key: "hasNearbyAirports",
    get: function get() {
      return (0, _some2.default)(this.searchResults.itineraries, function (i) {
        return i.hasNearbyOrigin || i.hasNearbyDestination;
      });
    }
  }, {
    key: "filterOutNearbyAirports",
    value: function filterOutNearbyAirports() {
      this.updateInitialState({});
      this.filters.airport.update(this.searchResults.searchRequest.requestAirportsFilterQuery, true);
    }
  }, {
    key: "totalFlightsCount",
    get: function get() {
      return (0, _size2.default)(this.allSearchResults);
    }
  }, {
    key: "filteredFlightsCount",
    get: function get() {
      return (0, _size2.default)(this.filteredSearchResults);
    }
  }, {
    key: "hasNoResults",
    get: function get() {
      var _this$allSearchResult;
      return this.searchResults.hasError || this.searchResults.isCompleted && !((_this$allSearchResult = this.allSearchResults) !== null && _this$allSearchResult !== void 0 && _this$allSearchResult.length);
    }
  }, {
    key: "shouldResetFilters",
    get: function get() {
      var _this$filteredSearchR;
      return this.searchResults.isCompleted && !this.hasNoResults && !((_this$filteredSearchR = this.filteredSearchResults) !== null && _this$filteredSearchR !== void 0 && _this$filteredSearchR.length);
    }
  }, {
    key: "availableAirlines",
    get: function get() {
      return (0, _map2.default)(this.filters.airline.state, "code");
    }
  }, {
    key: "AdPlacementsPayload",
    get: function get() {
      return (0, _adPlacments.getAdPlacementPayload)({
        searchRequest: this.searchResults.searchRequest,
        config: this.$env.config,
        $resources: this.filters.flightInfo.$resources
      });
    }
  }, {
    key: "preserveCurrentFilters",
    value: function preserveCurrentFilters() {
      this.preservedFilters = {
        stop: this.filters[_filters.FILTER_MAP.STOP].state,
        airline: this.filters[_filters.FILTER_MAP.AIRLINE].state,
        baggage: this.filters[_filters.FILTER_MAP.BAGGAGE].state,
        price: this.filters[_filters.FILTER_MAP.PRICE].state,
        airport: this.filters[_filters.FILTER_MAP.AIRPORT].state,
        time: this.filters[_filters.FILTER_MAP.TIME].state
      };
    }
  }, {
    key: "restorePreservedFilters",
    value: function restorePreservedFilters() {
      if ((0, _isEmpty2.default)(this.preservedFilters)) return;
      this.filters.setRestoringPreservedFilters(true);
      this.filters[_filters.FILTER_MAP.STOP].clone(this.preservedFilters.stop);
      this.filters[_filters.FILTER_MAP.AIRLINE].clone(this.preservedFilters.airline);
      this.filters[_filters.FILTER_MAP.BAGGAGE].clone(this.preservedFilters.baggage);
      this.filters[_filters.FILTER_MAP.PRICE].clone(this.preservedFilters.price);
      this.filters[_filters.FILTER_MAP.AIRPORT].clone(this.preservedFilters.airport);
      this.filters[_filters.FILTER_MAP.TIME].clone(this.preservedFilters.time);
      this.fareCalendar.setFiltersQuery(this.filters.queryStr);
    }
  }, {
    key: "restoreStopFilters",
    value: function restoreStopFilters() {
      this.filters[_filters.FILTER_MAP.STOP].clone(this.preservedFilters.stop);
    }
  }, {
    key: "restoreAirlineFilters",
    value: function restoreAirlineFilters() {
      this.filters[_filters.FILTER_MAP.AIRLINE].clone(this.preservedFilters.airline);
    }
  }, {
    key: "restoreBaggageFilters",
    value: function restoreBaggageFilters() {
      this.filters[_filters.FILTER_MAP.BAGGAGE].clone(this.preservedFilters.baggage);
    }
  }, {
    key: "restorePriceFilters",
    value: function restorePriceFilters() {
      if (this.preservedFilters.price.to === this.preservedFilters.price.max) {
        return;
      }
      if (this.filters[_filters.FILTER_MAP.PRICE].state.max > this.preservedFilters.price.to) {
        this.filters[_filters.FILTER_MAP.PRICE].clone(this.preservedFilters.price);
      }
    }
  }, {
    key: "restoreAirportFilters",
    value: function restoreAirportFilters() {
      this.filters[_filters.FILTER_MAP.AIRPORT].clone(this.preservedFilters.airport);
    }
  }, {
    key: "restoreTimeFilters",
    value: function restoreTimeFilters() {
      this.filters[_filters.FILTER_MAP.TIME].clone(this.preservedFilters.time);
    }
  }, {
    key: "cleanPreservedFilters",
    value: function cleanPreservedFilters() {
      this.preservedFilters = {};
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      if (initialState === void 0) {
        initialState = {};
      }
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "addItineraryGroupState",
    value: function addItineraryGroupState(itineraryGroup, index) {
      var newState = _objectSpread({}, this.itinerariesGroupState);
      newState[index] = _objectSpread({}, (0, _group.initializeGroupState)(itineraryGroup, this.searchResults.itineraryLegHashMap));
      this.itinerariesGroupState = newState;
    }
  }, {
    key: "updateItineraryGroupState",
    value: function updateItineraryGroupState(index, isInbound, newSelectedCode) {
      var _this$itinerariesGrou2 = this.itinerariesGroupState[index],
        inbound = _this$itinerariesGrou2.inbound,
        outbound = _this$itinerariesGrou2.outbound,
        selectedOutboundId = _this$itinerariesGrou2.selectedOutboundId,
        selectedInboundId = _this$itinerariesGrou2.selectedInboundId;
      if (!this.searchResults.searchRequest.isRoundTrip) {
        this.itinerariesGroupState[index] = {
          outbound: outbound,
          inbound: [],
          selectedInboundId: undefined,
          selectedOutboundId: newSelectedCode
        };
        var itineraryId = [selectedOutboundId].join(_constants.LEG_IDS_SEPARATOR);
        var selectedTimeItinerary = this.searchResults.itineraryLegHashMap[itineraryId];
        this.selectFareFamilyItinerary(selectedTimeItinerary.id);
      } else {
        var updatedGroup = (0, _group.updateItineraryGroup)({
          inbound: inbound,
          itineraryLegHashMap: this.searchResults.itineraryLegHashMap,
          itineraryGroup: this.searchResults.itineraries,
          selectedOutboundId: isInbound ? selectedOutboundId : newSelectedCode,
          selectedInboundId: isInbound ? newSelectedCode : selectedInboundId
        });
        this.itinerariesGroupState[index] = {
          outbound: outbound,
          inbound: updatedGroup.inbound,
          selectedInboundId: updatedGroup.inboundNextSelected,
          selectedOutboundId: updatedGroup.outboundNextSelected
        };
        if (!(0, _isEmpty2.default)(selectedOutboundId) && !(0, _isEmpty2.default)(selectedInboundId)) {
          var _itineraryId = [updatedGroup.outboundNextSelected, updatedGroup.inboundNextSelected].join(_constants.LEG_IDS_SEPARATOR);
          var _selectedTimeItinerary = this.searchResults.itineraryLegHashMap[_itineraryId];
          this.selectFareFamilyItinerary(_selectedTimeItinerary.id);
        }
      }
    }
  }, {
    key: "selectItineraryGroup",
    value: function selectItineraryGroup(group) {
      if ((0, _size2.default)(group) === 1) {
        this.selectFareFamilyItinerary(group[0].id);
      } else {
        this.selectedGroupItineraries = group;
      }
    }
  }, {
    key: "setFareFamilyItinerary",
    value: function setFareFamilyItinerary(itineraryId) {
      var itinerary = this.searchResults.getItinerary(itineraryId);
      this.selectedFareFamilyItinerary = itinerary;
    }
  }, {
    key: "selectFareFamilyItinerary",
    value: function selectFareFamilyItinerary(itineraryId) {
      var itinerary = this.searchResults.getItinerary(itineraryId);
      if ((0, _size2.default)(itinerary.fareFamilies) > 0 || (0, _get2.default)(itinerary, "hasFareFamilies", false)) {
        this.selectedFareFamilyItinerary = itinerary;
      } else {
        this.selectItinerary(itineraryId);
      }
    }
  }, {
    key: "selectItinerary",
    value: function selectItinerary(itineraryId) {
      this.selectedItinerary = this.searchResults.getItinerary(itineraryId);
      this.displayItinerary = undefined;
    }
  }, {
    key: "deselectItinerary",
    value: function deselectItinerary() {
      this.selectedItinerary = undefined;
    }
  }, {
    key: "deselectFareFamilyItinerary",
    value: function deselectFareFamilyItinerary() {
      this.selectedFareFamilyItinerary = undefined;
    }
  }, {
    key: "deselectItineraryGroup",
    value: function deselectItineraryGroup() {
      this.selectedGroupItineraries = [];
    }
  }, {
    key: "setDisplayItinerary",
    value: function setDisplayItinerary(itinerary) {
      this.displayItinerary = itinerary;
    }
  }, {
    key: "initializeGroupsState",
    value: function initializeGroupsState() {
      var _this3 = this;
      var cb = function cb(group) {
        return (0, _group.legacyInitializeGroupState)(group, _this3.searchResults.itineraryLegHashMap);
      };
      this.groupsState = (0, _map2.default)(this.itineraryGroups, cb);
    }
  }, {
    key: "updateGroupsState",
    value: function updateGroupsState(payload) {
      if (!(0, _isPlainObject2.default)(payload)) {
        return;
      }
      var groupIndex = payload.index;
      var groupState = this.groupsState[groupIndex];
      if (groupState) {
        var groupIds = (0, _map2.default)(this.itineraryGroups[groupIndex], "id");
        this.groupsState[groupIndex] = (0, _group.updateGroupState)({
          groupState: groupState,
          itineraryLegHashMap: this.searchResults.itineraryLegHashMap,
          payload: payload,
          groupIds: groupIds
        });
      }
    }
  }, {
    key: "fetchAdPlacements",
    value: function fetchAdPlacements() {
      this.adSolution.fetchAdPlacements(this.AdPlacementsPayload);
    }
  }, {
    key: "initializeAutoruns",
    value: function initializeAutoruns() {
      var _this4 = this;
      this.filterDisposer = (0, _mobx.autorun)(function () {
        var urlParams = (0, _common.getFilterURLParams)();
        _this4.filters.initialize(_this4.filtersData, _this4.searchQuery, urlParams);
      });
      this.sortDisposer = (0, _mobx.reaction)(function () {
        return _this4.topScoreItineraries;
      }, function (topScoreItineraries) {
        return _this4.sort.setTopScoreItineraries(topScoreItineraries);
      });
      this.sortDefaultKeyDisposer = (0, _mobx.autorun)(function () {
        var defaultSortKey = _this4.$env.config.isMobile ? _sort4.MOBILE_DEFAULT_SORT_KEY : _constants.DEFAULT_SORT_KEY;
        var isRoundTrip = _this4.searchResults.searchRequest.isRoundTrip;
        _this4.sort.initializeDefaultKey(isRoundTrip ? _constants.DEFAULT_SORT_KEY : defaultSortKey);
      });
      this.fareCalendarDisposer = (0, _mobx.autorun)(function () {
        if (!_this4.filters.isRestoringPreservedFilters) {
          _this4.fareCalendar.setFiltersQuery(_this4.filters.queryStr);
        }
      });
      this.groupsDisposer = (0, _mobx.autorun)(function () {
        if (!(0, _isEmpty2.default)(_this4.itineraryGroups)) {
          _this4.initializeGroupsState();
        }
      });
    }
  }, {
    key: "cleanupAutoruns",
    value: function cleanupAutoruns() {
      this.filterDisposer();
      this.sortDisposer();
      this.fareCalendarDisposer();
      this.groupsDisposer();
      this.sortDefaultKeyDisposer();
    }
  }]);
  return SearchPageStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupPaths", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DEFAULT_GROUP_PATHS;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "minGroupLength", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.MIN_GROUP_LENGTH;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedGroupItineraries", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedFareFamilyItinerary", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return undefined;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedItinerary", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return undefined;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayItinerary", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return undefined;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerariesGroupState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupsState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "preservedFilters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerariesGroups", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itinerariesGroups"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryFromGroupState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryFromGroupState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "firstNearByAirportItineraryId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstNearByAirportItineraryId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isNearbyAirportInTopPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNearbyAirportInTopPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filteredSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortedSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryGroups", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryGroups"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryGroupMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryGroupMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupedSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupedByLegSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedByLegSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedItineraryFareFamilies", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedItineraryFareFamilies"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resultsWithoutTopPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resultsWithoutTopPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topScoreItineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topScoreItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topPicksItineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPicksItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTopPicksReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTopPicksReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isMobileTopPicksReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMobileTopPicksReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isDesktopTopPicksReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDesktopTopPicksReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortPriceDurationHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortPriceDurationHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isMultiCity", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiCity"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isEconomy", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEconomy"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasAdultsOnly", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAdultsOnly"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchRoute", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRoute"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFareCalendarAvailable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFareCalendarAvailable"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "parseSearchQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "parseSearchQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasNearbyAirports", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNearbyAirports"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterOutNearbyAirports", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "filterOutNearbyAirports"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "totalFlightsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalFlightsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filteredFlightsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredFlightsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasNoResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "shouldResetFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldResetFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableAirlines", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAirlines"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "AdPlacementsPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "AdPlacementsPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "preserveCurrentFilters", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "preserveCurrentFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restorePreservedFilters", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "restorePreservedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreStopFilters", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "restoreStopFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreAirlineFilters", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "restoreAirlineFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreBaggageFilters", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "restoreBaggageFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restorePriceFilters", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "restorePriceFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreAirportFilters", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "restoreAirportFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "restoreTimeFilters", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "restoreTimeFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "cleanPreservedFilters", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "cleanPreservedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "addItineraryGroupState", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "addItineraryGroupState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateItineraryGroupState", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "updateItineraryGroupState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectItineraryGroup", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "selectItineraryGroup"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFareFamilyItinerary", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "setFareFamilyItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectFareFamilyItinerary", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "selectFareFamilyItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectItinerary", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "selectItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "deselectItinerary", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "deselectItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "deselectFareFamilyItinerary", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "deselectFareFamilyItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "deselectItineraryGroup", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "deselectItineraryGroup"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setDisplayItinerary", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "setDisplayItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeGroupsState", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "initializeGroupsState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateGroupsState", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "updateGroupsState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetchAdPlacements", [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, "fetchAdPlacements"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeAutoruns", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "initializeAutoruns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "cleanupAutoruns", [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, "cleanupAutoruns"), _class.prototype)), _class));